import { ArticlePageType } from "../../types/optimizely/articlePage";
import { OptimizelyExpandedValue } from "../../types/optimizely/expanded";

export const articlePageTypeName = ["ArticlePage", "PressReleasePage", "NewsPage"];

export const isArticlePage = (content: OptimizelyExpandedValue): content is ArticlePageType => {
  return content.contentType.some((type) => articlePageTypeName.includes(type));
}